import { convertDataToStringFromArray } from 'utils/downloadFile'
// ------------------------------- //
//             Export
// ------------------------------- //

export const getProcessingTimeExport = (folders) => {
  const processingTimeHeader = [
    'SIRET',
    'Nom de l\'établissement',
    'Type de contrôle',
    'Référence dossier',
    'Rang du contrôle',
    'Date de création de l\'acte',
    'Date de traitement',
    'Délai de traitement (en jours)',
    'Résultat traitement',
  ]

  const getProcessingTimeRows = (folders) => {
    return folders.map(folder => {

      const folderRow = [
        folder.SIRET,
        folder.structureName,
        folder.controlType,
        folder.folderId,
        folder.rank,
        folder.creationDate,
        folder.processingDate,
        folder.timeLimit,
        folder.result,
      ]
      return convertDataToStringFromArray(folderRow) //allows consistent alignment in excel column
    })
  }

  // prepare data
  return [
      // Header array
      processingTimeHeader,
      ...getProcessingTimeRows(folders)
  ]
}